import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, Leaf, User } from 'lucide-react';
import { BRAND_PILLARS } from '../../data/brandData';

const iconMap: Record<string, React.ReactNode> = {
  ShieldCheck: <ShieldCheck className="w-10 h-10" />,
  Zap: <Zap className="w-10 h-10" />,
  Leaf: <Leaf className="w-10 h-10" />,
  User: <User className="w-10 h-10" />,
};

export function KeyPillars() {
  return (
    <section className="py-20 bg-black text-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 text-center">
          {BRAND_PILLARS.map((pillar, index) => (
            <motion.div
              key={pillar.id}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex flex-col items-center"
            >
              <div className="w-20 h-20 rounded-full bg-white/10 flex items-center justify-center mb-6 backdrop-blur-sm">
                {iconMap[pillar.icon]}
              </div>
              <h3 className="text-xl font-bold mb-2">{pillar.label}</h3>
              <p className="text-gray-400 text-sm font-medium uppercase tracking-wider">
                {pillar.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
